// extracted by mini-css-extract-plugin
export var container = "_d8-0";
export var popoverContent = "_d8-1";
export var tosLink = "_d8-2";